export {}
URLSearchParams.prototype.Entries = function (): Array<[string, string]> {
	return Array.from(this.entries())
}
